export type PipeFunc<T1, R> = (arg: T1) => R;
export interface Pipe {
  <T1, T2>(fn1: PipeFunc<T1, T2>): PipeFunc<T1, T2>;
  <T1, T2, T3>(fn1: PipeFunc<T1, T2>, fn2: PipeFunc<T2, T3>): PipeFunc<T1, T3>;
  <T1, T2, T3, T4>(
    fn1: PipeFunc<T1, T2>,
    fn2: PipeFunc<T2, T3>,
    fn3: PipeFunc<T3, T4>,
  ): PipeFunc<T1, T4>;
  <T1, T2, T3, T4, T5>(
    fn1: PipeFunc<T1, T2>,
    fn2: PipeFunc<T2, T3>,
    fn3: PipeFunc<T3, T4>,
    fn4: PipeFunc<T4, T5>,
  ): PipeFunc<T1, T5>;
  // ... and so on
}

const pipe: Pipe = (...funcs: PipeFunc<any, any>[]): PipeFunc<any, any> => {
  return (arg: any): any => {
    return funcs.reduce((acc, fn) => fn(acc), arg);
  };
};

export default pipe;
